import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getEvents } from "../api/eventApi";
import Pagination, { DEFAULT_PER_PAGE } from "../components/Pagination";
import { formatDateTime } from "../utils/dateFormat";

export default function EventsList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(DEFAULT_PER_PAGE);
  const [total, setTotal] = useState(0);
  const navigate = useNavigate();

  const load = async () => {
    setLoading(true);
    try {
      const res = await getEvents({ page, per_page: perPage });
      setItems(res.data.items);
      setTotal(res.data.total);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, [page, perPage]);

  return (
    <AdminLayout title="Events">
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">Event List</h5>
          <div className="table-responsive">
            <table className="table table-striped table-hover align-middle mb-0">
              <thead>
                <tr>
                  <th>Title</th>
                  <th>User Name</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading && (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Loading...
                    </td>
                  </tr>
                )}
                {!loading && items.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center text-muted">
                      No events found.
                    </td>
                  </tr>
                )}
                {!loading &&
                  items.map((row) => (
                    <tr key={row.id}>
                      <td>{row.summary}</td>
                      <td>
                        {row.user_first_name || row.user_last_name
                          ? `${row.user_first_name || ""} ${row.user_last_name || ""}`.trim()
                          : "-"}
                      </td>
                      <td>{formatDateTime(row.start)}</td>
                      <td>{formatDateTime(row.end)}</td>
                      <td>
                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => navigate(`/events/detail/${row.id}`)}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
          <Pagination
            page={page}
            total={total}
            perPage={perPage}
            onPageChange={setPage}
          />
        </div>
      </div>
    </AdminLayout>
  );
}
